import React from 'react';
import { compose } from 'redux';

import {
  withScreenActions,
  withSignatureActions,
} from '../../../hocs/withActions';
import { withScreenData } from '../../../hocs/withData';
import DeclarationForm from './DeclarationForm';

const SignatureForm = ({
  SubmitSignatureForm = () => {},
  EnableSpinner = () => {},
}) => {
  return (
    <>
      <DeclarationForm
        EnableSpinner={EnableSpinner}
        SubmitSignatureForm={SubmitSignatureForm}
      />
    </>
  );
};

export default compose(
  withSignatureActions,
  withScreenData,
  withScreenActions
)(SignatureForm);
